import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalWindowModule } from '../modal-window/modal-window.module';
import { PromptComponent } from './prompt.component';
import { DxNumberBoxModule, DxCheckBoxModule } from 'devextreme-angular';
import { SharedModule } from '../../../shared/shared.module';
import { PromptService } from './prompt.service';

@NgModule({
  declarations: [PromptComponent],
  exports: [PromptComponent],
  imports: [CommonModule, SharedModule, ModalWindowModule, DxNumberBoxModule, DxCheckBoxModule],
  providers: [PromptService],
})
export class PromptModule {}
